import React from 'react';

const logos = [
  { name: 'Dash Square', path: 'https://supoassets.s3.ap-south-1.amazonaws.com/public/sites/omniviewlabs/assets/Clients/dashsquare.webp' },
  { name: 'Austins', path: 'https://supoassets.s3.ap-south-1.amazonaws.com/public/sites/omniviewlabs/assets/Clients/Austins.png' },
  { name: 'Kate N Mark', path: 'https://supoassets.s3.ap-south-1.amazonaws.com/public/sites/omniviewlabs/assets/Clients/Kate.png' },
  { name: 'Looking Good Furniture', path: 'https://supoassets.s3.ap-south-1.amazonaws.com/public/sites/omniviewlabs/assets/Clients/LookingGood.png' },
  { name: 'Fiore Living', path: 'https://supoassets.s3.ap-south-1.amazonaws.com/public/sites/omniviewlabs/assets/Clients/Fiore.png' },
  { name: 'Furnezo', path: 'https://supoassets.s3.ap-south-1.amazonaws.com/public/sites/omniviewlabs/assets/Clients/Furnezo.png' },
  { name: 'Furnova', path: 'https://supoassets.s3.ap-south-1.amazonaws.com/public/sites/omniviewlabs/assets/Clients/Furnova.png' },
  { name: 'ManaGoodu', path: 'https://supoassets.s3.ap-south-1.amazonaws.com/public/sites/omniviewlabs/assets/Clients/Managoodu.png' },
  { name: 'KairaFabrics', path: 'https://supoassets.s3.ap-south-1.amazonaws.com/public/sites/omniviewlabs/assets/Clients/KairaFabrics.webp' },
  { name: 'AkabFabrics', path: 'https://supoassets.s3.ap-south-1.amazonaws.com/public/sites/omniviewlabs/assets/Clients/AkabFabrics.webp' },
];

const Trustbar: React.FC = () => {
  return (
    <section id="trustbar" className="py-10 bg-white border-y border-gray-100 overflow-hidden no-scrollbar">
      <div className="container mx-auto px-6 mb-6">
        <div className="text-center">
          <h2 data-animation="fade-in-up" className="text-xs font-bold text-gray-400 uppercase tracking-[0.3em]">
            Trusted by the biggest names in retail
          </h2>
        </div>
      </div>
      
      <div className="relative flex overflow-hidden group">
        <div className="animate-marquee whitespace-nowrap flex items-center">
          {/* First Set */}
          {logos.map((logo, index) => (
            <div key={`logo-1-${index}`} className="mx-8 md:mx-14 flex-shrink-0">
              <img
                src={logo.path}
                alt={logo.name}
                className="h-9 md:h-12 object-contain"
              />
            </div>
          ))}
          {/* Second Set (Duplicate for seamless loop) */}
          {logos.map((logo, index) => (
            <div key={`logo-2-${index}`} className="mx-8 md:mx-14 flex-shrink-0">
              <img
                src={logo.path}
                alt={logo.name}
                className="h-9 md:h-12 object-contain"
              />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Trustbar;